<ui-info-field-item [label]="label">
  <ng-container *ngIf="items?.length; else notAvailableTemplate">
    <div *ngVar="{ isOpened: isOpened$ | async, fits: fits$ | async } as state" class="tw-flex">
      <div class="info-field-list__content">
        <ng-template
          [cropContentUntilFit]="items"
          [opened]="state.isOpened"
          let-value="value"
          (fitEvent)="onFitEvent($event)"
        >
          <p class="content-value">
            {{ value }}
          </p>
        </ng-template>
      </div>
      <ng-container *ngIf="state.fits !== null">
        <ui-svg-icon
          *ngIf="!state.fits"
          class="info-field-list__icon"
          [class.info-field-list__icon_flipped]="state.isOpened !== null && state.isOpened"
          [name]="iconNames.Down"
          [width]="20"
          (click)="toggleHeight()"
        ></ui-svg-icon>
      </ng-container>
    </div>
  </ng-container>
</ui-info-field-item>
<ng-template #notAvailableTemplate>
  {{ notAvailable }}
</ng-template>
